import React, { useState } from 'react';

export default function (props) {
    return (
        <div className={props.className + " input-group-sm"}>
            {
                props.label ? <div className="mb-2">{props.label}</div> : null
            }
            <select
                className={props.className}
                onChange={props.onChange}
                value={props.value}
                className="form-control"
            >
                {
                    props.options.map(i => (
                        <option selected={i.value == props.value} value={i.value}>{i.label}</option>
                    ))
                }
            </select>
        </div>
    )
  }
  